import { loadable } from '@owl-frontend/components';

// if you get a typing error in this file, you probably need to define your page parts.

export const DossierDetailPage = loadable(
  () => import('./dossier-details/DossierDetailsContainer')
);

export const InsightsPage = loadable(
  () => import('./insights/InsightsLandingContainer')
);
export const DossiersPage = loadable(
  () => import('./dossiers/DossiersLandingContainer')
);

export const UsersManagementPage = loadable(
  () => import('./users/UsersContainer')
);
